"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const theme_1 = __importDefault(require("../../styles/theme"));
const authSlice_1 = require("./authSlice");
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const utils_1 = require("../../utils/utils");
const store_1 = require("../../store");
const text_1 = __importStar(require("../../components/text/text"));
const input_1 = __importStar(require("../../components/input/input"));
const styles_1 = __importDefault(require("../../styles/styles"));
const analytics_1 = require("../../utils/analytics/analytics");
const ResendEmailConfirmation = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const [message, setMessage] = (0, react_1.useState)('');
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [email, setEmail] = (0, react_1.useState)('');
    const performSendEmailVerification = async () => {
        setIsLoading(true);
        const result = await dispatch((0, authSlice_1.requestConfirmEmail)());
        logEventWithExtraProperties('api_call', {
            name: 'resend_verification_email',
            status: 'submitted',
            location: 'screen_ResendEmailConfirmation',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'resend_verification_email',
                status: 'success',
                location: 'screen_ResendEmailConfirmation',
            });
            setMessage(result.payload.message);
            setErrors(undefined);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'resend_verification_email',
                status: 'fail',
                location: 'screen_ResendEmailConfirmation',
            });
            setMessage('');
            setErrors(result.payload);
        }
        setIsLoading(false);
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, titleText: "Email Confirmation", subTitleText: "Please provide the email to receive a new confirmation", subTitleColor: theme_1.default.colors.COLOR_GRAY_DARK, backArrow: true, isLoading: isLoading, footer: react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Resend Email", onPress: performSendEmailVerification, eventName: "return_to_app" }) },
        react_1.default.createElement(react_native_1.View, null,
            message ? (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChildHorizontalVertical] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_PRIMARY }, message))) : (react_1.default.createElement(react_native_1.View, null)),
            react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_EMAIL, label: "Your email", placeholder: "Your email", setValue: setEmail, error: (0, utils_1.getError)('email', errors), value: email }))));
};
exports.default = ResendEmailConfirmation;
